export class AttributeListBE {
  constructor(private id?: number, description?: string, weight?: number, co2Impactperkg?: number, MHNo?: string, supplierName?: string) {
        this.Id = id;
        this.Description = description;
        this.Weight = weight;
        this.CO2Impactperkg = co2Impactperkg;
        this.MHno = MHNo;
        this.SupplierName = supplierName;
    }
    Id: number;
    Description: string;
    CO2Impactperkg: number;
    Weight: number;
    AlternativeId: number;
    Active = true;
    Selected = false;
    MHno: string;
    SupplierName: string;
}

export class MaterialCompositionBE {
  constructor(private id?: number, materialId?: number, compositionId?: number, composition?: number, materialName?: string, weight?: number, co2Impactperkg?: number) {
        this.Id = id;
        this.MaterialId = materialId;
        this.Composition = composition;
        this.CompositionId = compositionId;
        this.MaterialName = materialName;
        this.Weight = weight;
        this.CO2Impactperkg = co2Impactperkg;
    }
    Id: number;
    MaterialId: number;
    Composition: number;
    CompositionId: number;
    MaterialName: string;
    CO2Impactperkg: number;
    Weight: number;
}




// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/shared/attribute-list.model.ts